export default "__VITE_ASSET__65157025__"